<template>
  <div>
    <a-upload action="" list-type="picture-card" :file-list="fileList" :custom-request="uploadFile" @preview="handlePreview" @change="handleChange">
      <div v-if="fileList.length < 3 && isEdit === true">
        <a-icon type="plus" />
        <div class="ant-upload-text">上传</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" width="40%" height="40%" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { uploadImage } from '@/api/project/case';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: []
    };
  },
  watch: {
    dataList: {
      immediate: true,
      handler(val) {
        this.fileList = this.dataList || [];
      }
    },
    fileList: {
      immediate: true,
      handler(val) {
        this.$emit('update:dataList', this.fileList);
      }
    }
  },
  methods: {
    uploadFile(data) {
      const file = data.file;
      const formData = new FormData();
      formData.append('resource', file);

      uploadImage(formData)
        .then(response => {
          const fileData = {
            uid: file.uid, // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
            name: file.name, // 文件名
            status: 'done', // 状态有：uploading done error removed
            response: '成功', // 服务端响应内容
            url: response.data.resource_url
          };
          this.fileList.push(fileData);
          this.$message.success('图片上传成功');
        })
        .catch(() => {
          this.$message.error('图片上传失败');
        });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList.filter(item => item.status === 'done');
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-upload-select-picture-card {
  width: 64px;
  height: 64px;
  margin: 2px 2px -2px 2px;
}
/deep/.ant-upload-list-picture-card .ant-upload-list-item {
  width: 64px;
  height: 64px;
  margin: 2px 0;
  padding: 2px;
}
/deep/.ant-upload-list-picture-card-container {
  width: 64px;
  height: 64px;
  margin: 0 2px;
}
</style>
